// import state from './state'
// import * as getters from './getters'
// import * as mutations from './mutations'
import * as actions from './actions'

// initial state
const state = {
  price: {
    legal_fee: {
      subtotal: '',
      cali_fee: '',
      weight_tax: '',
      revenue_stamp_fee: ''
    },
    price: {
      subtotal: '',
      base_price: '',
      oil_exchanged_fee: ''
    },
    total: '',
    coupon_fee: '',
    tax: ''
  }
}

// getters
const getters = {
  price: (state, getters) => {
    return state.price
  }
}

// mutations
const mutations = {
  SET_PRICE (state, data) {
    state.price = data
  }
}

// actions
// const actions = {
//   async setEstimate (context) {
//     const result = await price.get()
//     context.commit('SET_PRICE', result.data)
//   }
// }

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
